export const TemplateType = Object.freeze({
  EMAIL: 'email',
  SMS: 'sms',
  TEXT: 'text',
});

export const TemplateDocumentLevel = Object.freeze({
  HEADER: 'header',
  LINE: 'line',
});
